import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styled from 'styled-components';

import { SaveToProfileButton } from '@ratehub/base-ui';

import MORTGAGE_CALCULATOR_SIGN_IN_MESSAGES from '../definitions/MortgageCalculatorSignInMessages';


const CLASS_NAME_SAVE_TO_PROFILE_CONTAINER = 'save-to-profile-button-container';

function MortgageSaveToProfileContainer({ dataName }) {
    return (
        <StyledDiv
            className={classNames(
                'rh-my-0_5',
                'rh-mx-0_25',
            )}
        >
            <SaveToProfileButton
                dataName={dataName}
                signInMessages={MORTGAGE_CALCULATOR_SIGN_IN_MESSAGES}
            />
        </StyledDiv>
    );
}

MortgageSaveToProfileContainer.propTypes = {
    dataName: PropTypes.string,
};

MortgageSaveToProfileContainer.defaultProps = {
    dataName: 'mtg-calculator-SaveToProfile',
};

const StyledDiv = styled.div`
    display: flex;
    justify-content: flex-end;
`;

export default MortgageSaveToProfileContainer;
export { CLASS_NAME_SAVE_TO_PROFILE_CONTAINER };
